import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  list: {
    banners: {} as any,
  } as any,
  positions: {} as any,
  details: {} as any,
  detailsPosition: {} as any,
};

const bannerSlice = createSlice({
  name: 'banner',
  initialState,
  reducers: {
    requestBanners: (_state, _action: PayloadAction<{ page?: number; limit?: number }>) => {},
    saveBanners: (_state, _action: PayloadAction<{ list: any }>) => {
      _state.list = _action.payload.list;
    },
    requestBanner: (_state, _action: PayloadAction<{ id: any }>) => undefined,
    saveBanner: (_state, _action: PayloadAction<{ data: any }>) => {
      _state.details = _action.payload.data;
    },
    createBanner: (_state, _action: PayloadAction<{ data: any }>) => undefined,
    updateBanner: (_state, _action: PayloadAction<{ data: any }>) => undefined,
    deleteBanner: (_state, _action: PayloadAction<{ data: any }>) => undefined,
    // vị trí
    requestPostionBanners: () => undefined,
    savePostionBanners: (_state, _action: PayloadAction<{ list: any }>) => {
      _state.positions = _action.payload.list;
    },
    requestDetailsPostionBanner: (_state, _action: PayloadAction<{ id: any }>) => undefined,
    saveDetailsPostionBanner: (_state, _action: PayloadAction<{ data: any }>) => {
      _state.detailsPosition = _action.payload.data;
    },
    updateDetailsPostionBanner: (_state, _action: PayloadAction<{ data: any }>) => undefined,
    deleteDetailsPostionBanner: (_state, _action: PayloadAction<{ id: any }>) => undefined,
  },
});

export default bannerSlice;
